import { createGlobalStyle } from "styled-components";
import theme from "./theme";

const GlobalStyles = createGlobalStyle`
  /* Font preload hint: add this to public/index.html <head>:
     <link rel="preconnect" href="https://fonts.googleapis.com">
     <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
     <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700;800&display=swap" rel="stylesheet">
  */

  *, *::before, *::after { box-sizing: border-box; }
  html { font-size: 16px; scroll-behavior: smooth; }
  body {
    margin: 0;
    font-family: ${theme.typography.fontFamily.primary};
    color: ${theme.colors.text.primary};
    background: #0a0f1c;
    overflow-x: hidden; /* Prevent horizontal scroll from decorative elements */
  }

  /* Using a more playful, rounded font for headings */
  h1, h2, h3, .font-fredoka {
    font-family: ${theme.typography.fontFamily.heading};
  }

  /* Animation for elements fading in on scroll */
  .reveal {
    opacity: 0;
    transform: translateY(30px);
    transition: opacity 0.6s ease-out, transform 0.6s ease-out;
  }

  .reveal.visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* New theme card styles */
  .card {
    background: white;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    overflow: hidden;
    transition: transform 0.3s;
  }

  .card:hover {
    transform: scale(1.05);
  }

  /* New theme button styles */
  .btn-primary {
    background: linear-gradient(90deg, ${theme.colors.gradient.from}, ${theme.colors.gradient.to});
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 8px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 75, 43, 0.3);
  }

  a { color: inherit; text-decoration: none; }
  img { max-width: 100%; display: block; }
  button { font: inherit; }

  /* better focus */
  :focus-visible {
    outline: 3px solid ${theme.colors.action};
    outline-offset: 2px;
    border-radius: 6px;
  }

  /* container utility */
  .container { width: 100%; max-width: 1200px; margin: 0 auto; padding: 0 ${theme.spacing[4]}; }
`;
export default GlobalStyles;
